import { TERMS, termDiscount } from "@/data/vehicles";
import { useLang } from "@/i18n/LanguageContext";

// Segmented control for rental length (1 / 6 / 12 / 24 months) – shared by the gallery and the detail page.
export const TermSwitch = ({ value, onChange, compact = false, className = "" }) => {
  const { t } = useLang();
  return (
    <div className={`inline-flex items-center rounded-full border border-white/10 bg-white/[0.04] p-1 ${className}`} role="radiogroup" data-testid="term-switch">
      {TERMS.map((m) => {
        const active = m === value;
        const d = termDiscount(m);
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(m)}
            className={`relative rounded-full font-semibold transition-colors ${compact ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm"} ${
              active ? "bg-orange-500 text-black shadow-lg shadow-orange-500/30" : "text-zinc-400 hover:text-white"
            }`}
            data-testid={`term-${m}`}
          >
            {m === 1 ? t("vehicles.month1") : `${m} ${t("vehicles.monthsN")}`}
            {d > 0 && (
              <span className={`ml-1.5 text-[10px] font-bold ${active ? "text-black/70" : "text-emerald-400"}`}>−{Math.round(d * 100)} %</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TermSwitch;
